<template>
  <search-group title="" @search="findData" @clear="clearValue">
    <Row :gutter="24">
      <Col span="3">
        <Select placeholder="是否显示" v-model="searchData.houseTypeConfigStatus">
          <Option value="">请选择</Option>
          <Option  v-for="item in conditionList" :value="item.value" :key="'keyA'+item.value">{{item.text}}</Option>
          <!--<option value=""></option>-->
        </Select>
      </Col>
      <Col span="6">
        <Input placeholder="按项目名称或房型名称搜索！" v-model="searchData.q" @keyup.enter.native="findData"></Input>
      </Col>
    </Row>
  </search-group>
</template>
<script>
  // import SearchGroup from 'components/SearchGroup/index';
  import { getSelectedData } from "api/houseTypeConfig"
  export default {
    name: "SearchList",
    created(){
      getSelectedData().then( res => {
        this.conditionList = res.data.houseTypeConfigStatusEnums
      })

    },
    components: {
       // SearchGroup
    },
    props: {
    },
    data() {
      return {
        conditionList:[],
        searchData: {
          page:1,
          limit:10,
          houseTypeConfigStatus:'',
          q:''
        },
      }
    },
    methods:{
      findData(){
        this.$emit('findData', this.searchData);
      },
      clearValue(){
        this.searchData={
          page:1,
          limit:10,
          houseTypeConfigStatus:'',
          q:''
        }
      },

    }

  }
</script>

<style scoped>

</style>
